import React, {useEffect, useState} from 'react';
import {Greeting, GreetingPreview} from "types/Greeting";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";

type Props<T extends Greeting | GreetingPreview> = {
    greeting: T | null
    show: boolean
    onDelete?: (greeting: T) => any
    onDeleteFail?: (greeting: T, error: unknown) => any
    onCancel?: () => any
}

function DeleteGreeting<T extends Greeting | GreetingPreview>(props: Props<T>) {
    const {greeting, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(greeting?.title || 'this greeting');
    const {mutateAsync: deleteGreeting} = useMutation(ngage.greetings.destroy)

    const {notify} = useNotifications()

    useEffect(() => {
        if (greeting) setName(greeting.name)
    }, [greeting]);

    async function handleDeleteGreeting() {
        if (greeting) {
            try {
                await deleteGreeting(greeting.id)
                await invalidate('greetings.all')

                notify("success", "Greeting Deleted", `${greeting.title} has been permanently removed`)
                if (onDelete) onDelete(greeting)
            } catch (error) {
                notify("error", "Greeting Not Deleted", `${greeting.title} could not be removed`)
                if (onDeleteFail) onDeleteFail(greeting, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Greeting"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteGreeting}
            onCancel={handleCancel}
        />
    );
}

export default DeleteGreeting;